import { cn } from "tools/ui";
import { CalendarIcon, TimeIcon } from "components/Icons";
import useFixedPopover from "./useFixedPopover";

const base = "w-1.5 h-1.5 mx-auto rounded-full";

function Point({ color, position, events, popover }) {
  const { triggerRef, popoverPos, showPopover, hidePopover } =
    useFixedPopover();

  if (popover !== true) {
    return <div className={cn(base, color)} />;
  }

  const hasEvents = Array.isArray(events) && events.length > 0;
  const side = popoverPos?.side === "left" ? "left" : "right";

  return (
    <>
      <div
        ref={triggerRef}
        className={cn("absolute top-1 right-1 animate-pulse", position)}
        onMouseEnter={() => hasEvents && showPopover()}
        onMouseLeave={hidePopover}
      >
        <div className={cn(base, color)} />
      </div>
      {popoverPos && hasEvents && (
        <div
          className="fixed z-50"
          style={{ left: popoverPos.left, top: popoverPos.top }}
          onMouseEnter={showPopover}
          onMouseLeave={hidePopover}
        >
          <div
            className={cn(
              "absolute top-3 w-2 h-2 rotate-45 bg-blue-400",
              side === "right" ? "-left-1" : "-right-1",
            )}
          />
          <div className="w-56 overflow-hidden rounded-md border border-blue-100 bg-white shadow-xl shadow-blue-900/10">
            <div className="flex items-center gap-1.5 bg-blue-400 px-3 py-2">
              <span className="size-2 animate-pulse rounded-full bg-white/90" />
              <span className="text-[11px] font-bold uppercase tracking-wider text-white">
                Novedades
              </span>
              <span className="ml-auto rounded-full bg-white/20 px-1.5 py-0.5 text-[10px] font-bold text-white">
                {events.length}
              </span>
            </div>
            <ul className="flex flex-col gap-1.5 p-2">
              {events.slice(0, 3).map((ev) => (
                <li
                  key={ev.id}
                  className="flex items-start gap-2 rounded-lg bg-blue-50 px-2 py-1.5"
                >
                  <span className="mt-1 size-1.5 shrink-0 rounded-full bg-blue-500" />
                  <div className="min-w-0">
                    <span className="text-xs leading-tight text-blue-900">
                      {ev.category_name || ev.description || ""}
                    </span>
                    {ev.start_time ? (
                      <span className="flex items-center gap-1 text-[11px] text-slate-500">
                        <TimeIcon className="size-3 fill-current" />
                        {ev.start_time} - {ev.end_time || "--"}
                      </span>
                    ) : ev.start_date &&
                      ev.end_date &&
                      ev.start_date !== ev.end_date ? (
                      <span className="flex items-center gap-1 text-[11px] text-slate-500">
                        <CalendarIcon className="size-3 fill-current" />
                        {ev.start_date} → {ev.end_date}
                      </span>
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>
            {events.length > 3 && (
              <span className="px-3 pb-2 text-[11px]  text-blue-700">
                +{events.length - 3} más novedades
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Point;
